import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { marketplaceFAQData } from '../../data/marketplaceData';
import { ChevronDown, MessageCircle, ArrowRight } from 'lucide-react';
import { Button } from '../ui/button';

const MarketplaceFAQ = () => {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section className="py-24 bg-[#e3e4e6]/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-start">
          {/* Left Column - Header */}
          <div className="lg:sticky lg:top-32">
            <span className="inline-block px-4 py-2 bg-[#8bcaf9]/20 text-[#1297fd] rounded-full text-sm font-medium mb-4">
              FAQ
            </span>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
              Preguntas sobre{' '}
              <span className="text-[#1297fd]">Cloud Marketplace</span>
            </h2>
            <p className="text-lg text-[#c3c3c5] mb-8 leading-relaxed">
              Todo lo que necesitas saber sobre nuestro marketplace cloud y cómo puede transformar tu negocio.
            </p>

            {/* Contact CTA */}
            <div className="bg-white rounded-2xl p-6 border border-[#e3e4e6] shadow-lg">
              <div className="flex items-center gap-4 mb-4">
                <div className="w-12 h-12 rounded-xl flex items-center justify-center" style={{ background: 'linear-gradient(135deg, #4E95D9, #2B6FA8)' }}>
                  <MessageCircle className="w-6 h-6 text-white" />
                </div>
                <div>
                  <h4 className="font-bold text-gray-900">¿Más preguntas?</h4>
                  <p className="text-[#c3c3c5] text-sm">Agenda una demo personalizada</p>
                </div>
              </div>
              <Link to="/contacto?source=demo">
                <Button className="w-full text-white font-semibold rounded-xl py-3" style={{ background: 'linear-gradient(135deg, #4E95D9, #2B6FA8)' }}>
                  Agendar demo
                  <ArrowRight className="ml-2 w-4 h-4" />
                </Button>
              </Link>
            </div>
          </div>

          {/* Right Column - FAQ Items */}
          <div className="space-y-4">
            {marketplaceFAQData.map((item, idx) => (
              <div
                key={idx}
                className={`rounded-2xl border-2 transition-all duration-300 overflow-hidden ${
                  openIndex === idx
                    ? 'border-[#8bcaf9] bg-white shadow-lg'
                    : 'border-[#e3e4e6] bg-white hover:border-[#c3c3c5]'
                }`}
              >
                <button
                  onClick={() => setOpenIndex(openIndex === idx ? -1 : idx)}
                  className="w-full p-6 text-left flex items-center justify-between gap-4"
                >
                  <span className={`font-semibold text-lg transition-colors ${
                    openIndex === idx ? 'text-[#1297fd]' : 'text-gray-900'
                  }`}>
                    {item.question}
                  </span>
                  <div className={`w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0 transition-all ${
                    openIndex === idx
                      ? 'rotate-180'
                      : 'bg-[#e3e4e6]'
                  }`} style={openIndex === idx ? { background: 'linear-gradient(135deg, #4E95D9, #2B6FA8)' } : {}}>
                    <ChevronDown className={`w-5 h-5 transition-colors ${
                      openIndex === idx ? 'text-white' : 'text-gray-600'
                    }`} />
                  </div>
                </button>
                
                <div className={`overflow-hidden transition-all duration-300 ${
                  openIndex === idx ? 'max-h-96' : 'max-h-0'
                }`}>
                  <div className="px-6 pb-6">
                    <p className="text-[#c3c3c5] leading-relaxed">
                      {item.answer}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default MarketplaceFAQ;
